export interface ActiveSubscriptionStatusDto {
    status: ActiveSubscriptionStatus;
}

export enum ActiveSubscriptionStatus {
    DISABLED = 'DISABLED',
    ACTIVE = 'ACTIVE',
    UNPAID = 'UNPAID',
    BLOCKED = 'BLOCKED',
}
